import { subscribeSessionAgendaHubEvent } from "@/domains/offline/chat/sessionAgendaHubManager";
import {
    handleSessionPresenceUpdated,
    normalizeSessionPresencePayload,
} from "@/domains/shared/hooks/sessionPresenceNotificationHandler";
import { Roles } from "@/domains/shared/models/roles";
import { useEffect } from "react";

export const SESSION_AGENDA_UPDATED_EVENT = "mivo:session-agenda-updated";

export function useSessionAgendaRealtime(
    role?: string,
    emailVerified?: boolean,
    realtimeActive?: boolean,
    onAgendaUpdated?: () => void,
) {
    useEffect(() => {
        const canConnect =
            emailVerified === true &&
            realtimeActive === true &&
            (role === Roles.Therapist || role === Roles.Secretary);

        if (!canConnect) {
            if (import.meta.env.DEV) {
                console.info("[sessionAgendaRealtime] skipped", {
                    role,
                    emailVerified,
                    realtimeActive,
                });
            }
            return;
        }

        if (import.meta.env.DEV) {
            console.info("[sessionAgendaRealtime] subscribed", { role });
        }

        const unsubscribeAgenda = subscribeSessionAgendaHubEvent("SessionAgendaUpdated", () => {
            if (import.meta.env.DEV) {
                console.info("[sessionAgendaRealtime] SessionAgendaUpdated received");
            }
            onAgendaUpdated?.();
        });

        const unsubscribePresence = subscribeSessionAgendaHubEvent("SessionPresenceUpdated", (payload) => {
            if (import.meta.env.DEV) {
                console.info("[sessionAgendaRealtime] SessionPresenceUpdated received", payload);
            }
            handleSessionPresenceUpdated(
                normalizeSessionPresencePayload(payload),
                onAgendaUpdated,
                role,
            );
        });

        return () => {
            unsubscribeAgenda();
            unsubscribePresence();
        };
    }, [role, emailVerified, realtimeActive, onAgendaUpdated]);
}
